module.exports = __webpack_public_path__ + "img/23.f8909a84.jpg";